import React from 'react';
import { Box, Skeleton } from '@stockx/ui';

const SkeletonHeader = () => (
  <Box mt={6} mb={4}>
    <Skeleton isLoaded={false} width="160px" height="20px" />
  </Box>
);

export default SkeletonHeader;
